import React from 'react';
import { tags } from "config/recipe-template";
import Stack from "./TagSidebar/Tags";

const RecipeStack = ({
    api
}) => {
    return (
        <div className="react-recipe-stack">
            <Stack 
                category="role"
                tags = {tags.role} 
                api = {api}
            />
            <Stack 
                category="industry"
                tags = {tags.industry} 
                api = {api}
            />
            <Stack 
                category="platforms"
                tags = {tags.platforms} 
                api = {api}
            />    

            <Stack 
                category="usecases"
                tags = {tags.usecases} 
                api = {api}
            />                    
        </div>

    )
}
 
export default RecipeStack;
